import React, { useState } from 'react';
import {
  Box,
  Tabs,
  Tab,
  Typography,
  Paper,
} from '@mui/material';
import BroadcastPanel from './BroadcastPanel';
import NotificationTemplates from './NotificationTemplates';
import WelcomeDmPanel from './WelcomeDmPanel';

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

function TabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`notifications-tabpanel-${index}`}
      aria-labelledby={`notifications-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: { xs: 1.5, sm: 3 } }}>
          {children}
        </Box>
      )}
    </div>
  );
}

function a11yProps(index: number) {
  return {
    id: `notifications-tab-${index}`,
    'aria-controls': `notifications-tabpanel-${index}`,
  };
}

export default function NotificationsManager() {
  const [currentTab, setCurrentTab] = useState(0);

  const handleTabChange = (_event: React.SyntheticEvent, newValue: number) => {
    setCurrentTab(newValue);
  };

  return (
    <Box>
      <Paper sx={{ width: '100%', mb: 2 }}>
        <Tabs
          value={currentTab}
          onChange={handleTabChange}
          aria-label="notification management tabs"
          variant="scrollable"
          scrollButtons="auto"
          allowScrollButtonsMobile
        >
          <Tab label="Welcome DM" {...a11yProps(0)} />
          <Tab label="Broadcast" {...a11yProps(1)} />
          <Tab label="Templates" {...a11yProps(2)} />
          <Tab label="Preview" {...a11yProps(3)} />
          <Tab label="Scheduler" {...a11yProps(4)} />
        </Tabs>

        <TabPanel value={currentTab} index={0}>
          <WelcomeDmPanel />
        </TabPanel>

        <TabPanel value={currentTab} index={1}>
          <BroadcastPanel />
        </TabPanel>

        <TabPanel value={currentTab} index={2}>
          <NotificationTemplates />
        </TabPanel>

        <TabPanel value={currentTab} index={3}>
          <Typography variant="h6" gutterBottom>
            Notification Preview
          </Typography>
          <Typography color="text.secondary">
            Preview how notifications will appear on different devices
          </Typography>
        </TabPanel>

        <TabPanel value={currentTab} index={4}>
          <Typography variant="h6" gutterBottom>
            Campaign Scheduler
          </Typography>
          <Typography color="text.secondary">
            Schedule and manage notification campaigns
          </Typography>
        </TabPanel>
      </Paper>
    </Box>
  );
}
